// Submissions: provider applications from the public application form, through review to approval.
// This is the service-provider side (towing and service companies partnering with you). Hiring
// employees and contractors is a separate system: the careers page and Owner Console → Hiring.
const submissions = {
  title: 'Submissions',
  steps: () => [
    {
      target: null,
      title: 'Provider applications',
      body: 'Every towing or service company that fills in your provider application form shows up here. You review them, ask for documents, send the rate agreement and approve them; an approved provider company can start taking jobs.\n\nThis is not hiring. People applying for a job with you (employees and contractors) come through the careers page and are managed under Owner Console → Hiring.'
    },
    {
      target: 'submissions-tabs',
      title: 'Where each application is',
      body: 'New: just arrived. In Review: you have opened it and are collecting documents. Approved: signed and active. Denied: turned down. Completed: everything on file.',
      placement: 'bottom'
    },
    {
      target: 'submissions-tab-review',
      title: 'Try it: open In Review',
      body: 'Click the In Review tab.',
      action: 'click'
    },
    {
      target: 'submissions-list',
      title: 'A provider application',
      body: 'Open one to see the company, its insurance and W-9, the services and vehicle classes it offers, and the Application tab with every answer. From there you send the rate agreement, request a COI or a background check, add notes, and move it to the next stage.',
      placement: 'top'
    },
    {
      target: 'submissions-search',
      title: 'Search',
      body: 'Search by company, contact, city or vendor number inside the current tab.',
      placement: 'bottom'
    },
    {
      target: 'submissions-advanced',
      title: 'Advanced search',
      body: 'Filter by region, vehicle classes, services, date range and more when the list gets long.',
      placement: 'bottom'
    },
    {
      target: null,
      title: 'Where this leads',
      body: 'An approved provider company gets a login (Settings → Users), a site (Settings → Sites) and shows up for dispatch as soon as their insurance is current and a site is on duty.'
    }
  ]
};

export default submissions;
